window.addEventListener('DOMContentLoaded', function () {
    const form = document.getElementById('wptravelengine-checkout__form')
    if (!form) return

    const { wptravelengineCheckoutEvent: events } = window
    if (!events) return

    const updatePaymentMode = (value) => {
        const input = document.getElementById('wptravelengine_paypal_express_payment_mode')
        if (input) {
            input.value = value
        } else {
            const newInput = document.createElement('input')
            newInput.type = 'hidden'
            newInput.name = 'wptravelengine_paypal_express_payment_mode'
            newInput.id = 'wptravelengine_paypal_express_payment_mode'
            newInput.value = value
            form.appendChild(newInput)
        }
    }

    const handleCardButtonClick = () => {
        form.querySelectorAll('button.wpte-checkout__form-submit-button').forEach(button => {
            button.addEventListener('click', (e) => {
                updatePaymentMode(e.currentTarget.classList.contains('wte-paypal-express-card-button') ? 'card' : 'paypal_express')
                form.requestSubmit()
            })
        })
    }

    events.on('proceedCheckoutForm', function ({ form }) {
        if (form && 'paypalexpress_enable' === form.querySelector('.wpte-checkout__payment-method input[type=radio]:checked')?.id) {
            const { wteL10n: { checkout: { setLoading } } } = window
            setLoading(true)
        }
    })

    events.on('checkoutFragmentsOnUpdate', function ({ payment_method }) {
        if (payment_method === 'paypalexpress_enable') {
            handleCardButtonClick()
        }
    })
})